export const truncateText = (string: string, length = 10, suffix = "...") => {
  if (string.length > length) {
    const ending = length - suffix.length;

    return string.substring(0, ending) + suffix;
  } else {
    return string;
  }
};
